import styled from 'styled-components';

export const Nav = styled.ul`
  display: flex;
  margin-top: 44px;
  margin-left: 234px;
`;

export const NavItem = styled.li`
  padding: 12px 0;
  &:not(:last-child) {
    margin-right: 54px;
  }
`;

export const NavLink = styled.div`
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
  &:hover {
    color: rgba(232, 45, 75, 1);
  }

  &.active {
    color: rgba(232, 45, 75, 1);
  }
`;
